import { render, staticRenderFns } from "./FabricationStep.vue?vue&type=template&id=6cc148cb&"
import script from "./FabricationStep.vue?vue&type=script&lang=js&"
export * from "./FabricationStep.vue?vue&type=script&lang=js&"
import style0 from "./FabricationStep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports